import usePosOrderCurrentAction from "@/shared/atoms/usePosOrderCurrentAction";
import { PaymentMethodEnum } from "@/shared/utils/enum";
import { useCart } from "@/shared/hooks/useCartHook";
import usePosPaymentHook from "@/shared/hooks/usePosPaymentHook";
import usePosOrderHook from "@/shared/hooks/usePosOrderHook";
import useActionClick from "./useActionClick";
import PosMenuBottomActionButton, {
  PosMenuAction,
} from "../PosMenu/PosMenuBottomActionButton";
import { useTranslation } from "react-i18next";
import { CurrentActionTypes } from "@/shared/atoms/usePosOrderCurrentAction";
import {
  useHasSession,
  useShowPayments,
} from "@/shared/hooks/usePosOrderTableSessionHook";
import usePaySessionHook from "@/shared/hooks/usePaySessionHook";
import useCashDroConfigHook from "@/shared/hooks/useCashDroConfigHook";

const useCustomerPaysWithAction = (): PosMenuAction => {
  const { t } = useTranslation();
  const [cart] = useCart();
  const { hasCashPayment } = usePosPaymentHook();
  const { handlePostOrder } = usePosOrderHook(PaymentMethodEnum.CASH);
  const paySession = usePaySessionHook(PaymentMethodEnum.CASH);
  const hasSession = useHasSession();
  const showPayments = useShowPayments();
  const { isActive: isCashDroActive } = useCashDroConfigHook();

  return {
    name: "customerPaysWith" as CurrentActionTypes,
    label: t("posOrders.customerPaysWith"),
    set: (customerPaymentAmount) => {
      if (hasSession && showPayments) {
        paySession(customerPaymentAmount);
      } else {
        handlePostOrder(false, customerPaymentAmount);
      }
    },
    // The CashDro counts the cash and returns the change itself, so there is nothing to enter.
    filtered: hasCashPayment === false || isCashDroActive,
    disabled: hasSession ? !showPayments : cart?.length === 0,
    iconVariant: "money",
  };
};

const CustomerPaysWithAction = () => {
  const [currentAction] = usePosOrderCurrentAction();
  const action = useCustomerPaysWithAction();
  const handleClick = useActionClick(action);

  return (
    <PosMenuBottomActionButton
      action={action}
      isSelected={currentAction?.name === action.name}
      onClick={handleClick}
    />
  );
};

export default CustomerPaysWithAction;
